import React from "react"
import { useSelector } from "react-redux"
import InputGroup from "../InputGroup/InputGroup"

import "./SpouseMilitaryBasic.css"

const initialInputs = [
  {
    id: 0,
    userField: "serve_millitary",
    inputType: "select",
    placeHolder: "",
    title: "Did you serve in the Military?",
    className: "serve_millitary",
    required: true,
    options: [
      { id: 1, value: "Yes" },
      { id: 0, value: "No" }
    ]
  }
]

const SpouseMilitaryBasic = (props) => {
  const application = useSelector((state) => {
    return state.spouseApplication.application;
  })

  
  const requiredValidators = () => (input) => ({
    ...input,
    error: !!(input.required && input.value.length === 0),
    errorMessage: "Required"
  })

    const inputDataWithValues = initialInputs.map((input) => {
        let value = Object.byString(application, input.userField) || ""
        return {
            ...input,
            value
        }
    })

  return (
    <InputGroup
      {...props}
      containerClass="spouseActiveDutyContainer"
      inputData={inputDataWithValues}
      renderComponent={({ inputComponent, inputData, checkSubmittability }) => {
        return (
          <>
            {props.renderComponent({
              ...props,
              inputData,
              checkSubmittability,
              inputComponent: inputComponent,
              validators: [requiredValidators],
            })}
          </>
        );
      }}
    />
  )
}

export default SpouseMilitaryBasic
